import { useContext } from 'react';

import { ToastContext } from './ToastsProvider';

export const useToast = () => useContext(ToastContext);
